import type { AxiosError } from 'axios'
import axios from 'axios'

import environment from '@/environment'
import type {
  ConfigurationVersion,
  ConfigurationVersionUpdate,
} from '@/features/configuration/contexts/ConfigurationFileContext'

export const GET_RESOURCE_JSON_API = 'GET_RESOURCE_JSON'

export type ResourceJsonConfigResponse = {
  resourceId: string
  configurationVersion: ConfigurationVersion
  controllerId: string
  controllerEquipmentNumber: number
}

export type ResourceJsonErrorCode =
  | 'NOT_BATTERY'
  | 'NOT_LOCAL_CONTROL'
  | 'MULTIPLE_CONTROLLERS'
  | 'NO_EQUIPMENT_NUMBER'
  | 'CONTROLLER_NOT_FOUND'

const baseUrl = () => `${environment.services.resourcesManagerApiUrl}/resources`

export async function getResourceJson(resourceId: string): Promise<ResourceJsonConfigResponse | null> {
  try {
    const response = await axios.get<ResourceJsonConfigResponse>(`${baseUrl()}/${resourceId}/resource-json`)
    return response.data
  } catch (e) {
    if ((e as AxiosError).response?.status === 404) {
      return null
    }
    throw e
  }
}

export async function updateResourceJson(
  resourceId: string,
  payload: ConfigurationVersionUpdate,
): Promise<ResourceJsonConfigResponse> {
  const response = await axios.put<ResourceJsonConfigResponse>(`${baseUrl()}/${resourceId}/resource-json`, payload)
  return response.data
}

export async function restartControllerForResource(resourceId: string): Promise<void> {
  // The restart endpoint sits at the resource root (not nested under /resource-json) because
  // restart is a resource-level action — there's no semantic dependency on the resource.json
  // configuration file. If app.json ever gets an editor, nesting the restart under one config
  // file would be misleading.
  await axios.post(`${baseUrl()}/${resourceId}/restart-controller`)
}
